import { Component } from '@verndale/core';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $playButton: this.el?.querySelector('#video-play-button')
    };

    this.handlePlayButton();
  }

  addListeners() {
    if (this.dom.$playButton) {
      this.dom.$playButton.addEventListener('click', (e) => this.handlePlayButton(e));
    }
  }

  handlePlayButton(e) {
    if (e && e.target) {
      if (e.target) {
        e.target.parentNode.parentNode.parentNode.classList.add('clicked');
        e.target.parentNode.parentNode.parentNode.parentNode.classList.add(
          'clicked'
        );
      } else {
        e.target.classList.remove('clicked');
      }
    }
  }
}

export default Module;
